import {
  FETCH_PACKAGE_STOCK_LOCATIONS_PENDING,
  FETCH_PACKAGE_STOCK_LOCATIONS_REJECTED,
  FETCH_PACKAGE_STOCK_LOCATIONS_FULFILLED
} from "../constants/packageStockLocations";

const initialState = {
  pending: true,
  packageStockLocations: [],
  error: {}
};

export const packageStockLocations = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FETCH_PACKAGE_STOCK_LOCATIONS_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PACKAGE_STOCK_LOCATIONS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PACKAGE_STOCK_LOCATIONS_FULFILLED:
      return {
        ...state,
        packageStockLocations: action.response.results,
        pending: false,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/packageStockLocations.js